<div class="app-shell" *ngIf="isLoggedIn; else authOutlet">
  <app-sidebar
    class="app-shell__sidebar"
    [isOpen]="isSidebarOpen"
  ></app-sidebar>
  <div class="app-shell__main">
    <app-header
      class="app-shell__header"
      (menuToggle)="toggleSidebar()"
    ></app-header>
    <div class="app-shell__content">
      <router-outlet #o="outlet"></router-outlet>
    </div>
  </div>
  <div
    class="sidebar-backdrop"
    [class.is-visible]="isSidebarOpen"
    (click)="closeSidebar()"
  ></div>
</div>
<ng-template #authOutlet>
  <router-outlet #o="outlet"></router-outlet>
</ng-template>
